import { SupportedCollaterals } from "@astrid-dao/lib-base";

import { USE_TESTNET } from "../../../../config";

export type CollateralDecimalPerCollateralType = Record<SupportedCollaterals, number>;

const PRECISION_IN_ = {
  DECIMAL_6: 6,
  DECIMAL_8: 8,
  DECIMAL_10: 10,
  DECIMAL_12: 12,
  WAD: 18
};

const collateralDecimalPerCollateralType: CollateralDecimalPerCollateralType = {
  BUSD: PRECISION_IN_.WAD,
  DAI: PRECISION_IN_.WAD,
  DOT: PRECISION_IN_.DECIMAL_10,
  // KSM: PRECISION_IN_.DECIMAL_12,
  ceUSDC: PRECISION_IN_.DECIMAL_6,
  ceUSDT: PRECISION_IN_.DECIMAL_6,
  WASTR: PRECISION_IN_.WAD,
  // WBNB: PRECISION_IN_.WAD,
  WBTC: PRECISION_IN_.DECIMAL_8,
  WETH: PRECISION_IN_.WAD,
  DEV: PRECISION_IN_.WAD,
  SBY: PRECISION_IN_.WAD
};

const collateralDecimalPerCollateralTypeDev: CollateralDecimalPerCollateralType = {
  BUSD: PRECISION_IN_.WAD,
  DAI: PRECISION_IN_.WAD,
  DOT: PRECISION_IN_.DECIMAL_10,
  // KSM: PRECISION_IN_.DECIMAL_12,
  ceUSDC: PRECISION_IN_.DECIMAL_6,
  ceUSDT: PRECISION_IN_.DECIMAL_6,
  WASTR: PRECISION_IN_.WAD,
  // WBNB: PRECISION_IN_.WAD,
  WBTC: PRECISION_IN_.DECIMAL_8,
  WETH: PRECISION_IN_.WAD,
  DEV: PRECISION_IN_.WAD,
  SBY: PRECISION_IN_.WAD
};

export class CollateralDecimalService {
  static getPrecisionByCollateralType(collateralType: SupportedCollaterals): number {
    return USE_TESTNET
      ? collateralDecimalPerCollateralTypeDev?.[collateralType] ?? PRECISION_IN_.WAD
      : collateralDecimalPerCollateralType?.[collateralType] ?? PRECISION_IN_.WAD;
  }
}
